import { b as publicMutate } from '../requestsCollection-oNJgKLxK.js';
import 'react';
import 'graphql-request';
import 'lodash/cloneDeep';
import 'lodash/get';
import '../services/auth/index.js';
import './logToSlack.js';
import './cookies.js';
import 'cookies-next';
import '../cookies-l-jEMp6P.js';
import '../currency-_kacFJHO.js';
import '../language-BHHwgtQp.js';
import '../payment-a4IKjS7g.js';
import './isBot.js';
import './currency.js';
import '../context/index.js';
import '../product-_pRduMz7.js';
import 'next/router';
import '../helpers-qU2Vf3ni.js';
import './product.js';
import './logger.js';
import '../paths-ZKN3m62_.js';
import 'lodash';
import './fetchPolicyLookup.js';

const validateHCaptchaTokenOnServer = async (apolloConfig, hCaptchaToken, GetHCaptchaToken) => {
    try {
        const success = await publicMutate(apolloConfig(), {
            mutation: GetHCaptchaToken,
            variables: {
                hCaptchaToken,
            },
        }).then(res => res.data.GetHCaptchaToken.success);
        return success;
    }
    catch (e) {
        return false;
    }
};
var captcha = {};

export { captcha as default, validateHCaptchaTokenOnServer };
//# sourceMappingURL=captcha.js.map
